import {Button, type ButtonProps} from '@/components/app/button';
import {ActionMenu, type MenuAction} from '@/components/app/navigation';
export interface MenuButtonProps extends ButtonProps {
  actions?: MenuAction[];
  menuClassName?: string;
  menuStyle?: React.CSSProperties;
  menuOnShow?: () => void;
  menuOnHide?: () => void;
  align?: 'start' | 'end' | 'center';
}
export function MenuButton({
  actions,
  menuClassName,
  menuStyle,
  menuOnShow,
  menuOnHide,
  align,
  ...props
}: MenuButtonProps) {
  return (
    <ActionMenu
      actions={actions}
      className={menuClassName}
      style={menuStyle}
      onShow={menuOnShow}
      onHide={menuOnHide}
      align={align}
    >
      <Button {...props} />
    </ActionMenu>
  );
}
